import {Observable} from 'rxjs';
import {ApiV0Administration} from '../api.v0.administration';
import {BaseCollectionModel, Pagination, SearchModel} from '@yasc/yasc-material-components';
import {PermissionReq, PermissionRes, PermissionRolePatchReq} from '../../../../contracts/v0/cp';
import {RestApiService} from '../../../rest-api.service';

export class ApiV0AdminPermissions {
    segment = '/permissions';

    constructor(
        v0: ApiV0Administration,
        private rest: RestApiService
    ) {
        this.segment = v0.segment + this.segment;
    }

    add(dto?: PermissionReq): Observable<PermissionRes> {
        return this.rest.post<PermissionReq, PermissionRes>(`${this.segment}`, PermissionRes, dto);
    }

    patchRoleAssignment(permissionId: number, roleId: number, assigned: boolean): Observable<PermissionRes> {
        const dto: PermissionRolePatchReq = {roleId, assigned};
        return this.rest.patch<PermissionRolePatchReq, PermissionRes>(`${this.segment}/${permissionId}/role`, PermissionRes, dto);
    }

    search(dto?: SearchModel): Observable<BaseCollectionModel<PermissionRes>> {
        dto = dto ?? new SearchModel({
            pagination: new Pagination({
                index: 0,
                size: 500
            })
        });
        console.log(dto);
        return this.rest.post<SearchModel, BaseCollectionModel<PermissionRes>>(`${this.segment}/search`, PermissionRes, dto);
    }

    resetToDefaults(): Observable<BaseCollectionModel<PermissionRes>> {
        return this.rest.post<void, BaseCollectionModel<PermissionRes>>(`${this.segment}/reset`, PermissionRes);
    }
}